import React, { useState } from "react";
import { useAuth } from "../../contexts/authContext";
import { MyDataTable } from "../partials/data-tables/data-table-promoters.tsx";
import MainTabs from "../partials/main-tabs";
import FormModal from "../partials/form-modals/promoters/new-form.jsx";

const Promoters = () => {
	const { currentUser } = useAuth();
	const [isModalOpen, setModalOpen] = useState(false);

	const handleSubmit = (data) => {
		alert(`Submitted: ${JSON.stringify(data)}`);
	};

	return (
		<>
			<div class="main-tabs">
				<div class="mx-auto">
					<MainTabs tabIndexSelected={4} />
					<div id="myTabContent">
						<div class="flex justify-between w-full page-header">
							<div class="page-heading">
								<img src="../../../assets/icons/promoters-icon.png" alt="Fans" class="icon" />
								<h2 class="text-4xl font-bold dark:text-white">
									<span class="text-transparent bg-clip-text bg-gradient-to-r to-red-400 from-red-500">PROMOTERS</span>
								</h2>
							</div>
							<div>
								<button
									onClick={() => setModalOpen(true)}
									type="button"
									class="border text-slate-400 hover:text-red-400 border-slate-600 focus:outline-none focus:ring-2 focus:text-red-500 focus:ring-red-500 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
									New Promoter
								</button>
							</div>
						</div>
						<div class="shadow-xl bg-slate-500 p-4 rounded-lg tabpanel" id="profile" role="tabpanel" aria-labelledby="profile-tab">
							<MyDataTable onOpenForm={setModalOpen} />
						</div>
					</div>
				</div>

				<script src="https://unpkg.com/@themesberg/flowbite@1.2.0/dist/flowbite.bundle.js"></script>
				<div className="text-2xl font-bold pt-14">
					Hello {currentUser.displayName ? currentUser.displayName : currentUser.email}, you are now logged in.
				</div>
			</div>
			<div className="h-screen flex items-center justify-center">
				<FormModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
			</div>
		</>
	);
};

export default Promoters;
